var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.555,
    height: 84.555,
    viewBox: "0 0 84.555 84.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    "data-name": "Group 1726",
    transform: "translate(1265.213 -995)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 42.277,
    cy: 42.277,
    r: 42.277,
    transform: "translate(-1265.213 995)",
    fill: "#ffd442"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721",
    transform: "translate(-4096 81.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M3751.293,1122.267s15.277,15.925,28.648,0",
    transform: "translate(-891.138 -156.653)",
    fill: "none",
    stroke: "#594504",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M4.538,15.3l-.011-.005a8.052,8.052,0,1,1,9.556-1.905c0-.088.009-.181.009-.3a5.033,5.033,0,1,0-10.067,0,4.984,4.984,0,0,0,.507,2.2Z",
    transform: "translate(2850.919 942.407)",
    fill: "#594504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M4.538,0,4.528.005A8.052,8.052,0,1,0,14.083,1.91c0,.088.009.181.009.3a5.033,5.033,0,1,1-10.067,0,4.984,4.984,0,0,1,.507-2.2Z",
    transform: "translate(2899.235 957.706) rotate(180)",
    fill: "#594504"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile4);
export default __webpack_public_path__ + "static/media/smile4.0822c5984bc6dd8f90744a53c19ed169.svg";
export { ForwardRef as ReactComponent };